import { useQueryClient } from '@tanstack/react-query'
import { invalidateToken as invalidateRpcToken } from '@repo/rpc-codegen/fetch-rpc'

export function useRefetchAuth() {
  const queryClient = useQueryClient()

  function refetchAuth() {
    invalidateRpcToken()
    // invalidates all queries too
    return queryClient.invalidateQueries()
  }

  return { refetchAuth }
}
